/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SchemaDefinitionSummaryDto
 */
export interface SchemaDefinitionSummaryDto {
    /**
     * 
     * @type {string}
     * @memberof SchemaDefinitionSummaryDto
     */
    slug?: string;
    /**
     * 
     * @type {string}
     * @memberof SchemaDefinitionSummaryDto
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof SchemaDefinitionSummaryDto
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof SchemaDefinitionSummaryDto
     */
    purpose?: string;
    /**
     * 
     * @type {string}
     * @memberof SchemaDefinitionSummaryDto
     */
    version?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SchemaDefinitionSummaryDto
     */
    active?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SchemaDefinitionSummaryDto
     */
    scope?: string;
}

/**
 * Check if a given object implements the SchemaDefinitionSummaryDto interface.
 */
export function instanceOfSchemaDefinitionSummaryDto(value: object): value is SchemaDefinitionSummaryDto {
    return true;
}

export function SchemaDefinitionSummaryDtoFromJSON(json: any): SchemaDefinitionSummaryDto {
    return SchemaDefinitionSummaryDtoFromJSONTyped(json, false);
}

export function SchemaDefinitionSummaryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SchemaDefinitionSummaryDto {
    if (json == null) {
        return json;
    }
    return {
        
        'slug': json['slug'] == null ? undefined : json['slug'],
        'title': json['title'] == null ? undefined : json['title'],
        'description': json['description'] == null ? undefined : json['description'],
        'purpose': json['purpose'] == null ? undefined : json['purpose'],
        'version': json['version'] == null ? undefined : json['version'],
        'active': json['active'] == null ? undefined : json['active'],
        'scope': json['scope'] == null ? undefined : json['scope'],
    };
}

export function SchemaDefinitionSummaryDtoToJSON(json: any): SchemaDefinitionSummaryDto {
    return SchemaDefinitionSummaryDtoToJSONTyped(json, false);
}

export function SchemaDefinitionSummaryDtoToJSONTyped(value?: SchemaDefinitionSummaryDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'slug': value['slug'],
        'title': value['title'],
        'description': value['description'],
        'purpose': value['purpose'],
        'version': value['version'],
        'active': value['active'],
        'scope': value['scope'],
    };
}

